import React from 'react';

export default function GameMonitor() {
  return (
    <div className="w-full h-[calc(100vh-220px)] min-h-[720px] bg-slate-950">
      <iframe
        title="Game Telemetry Monitor"
        src="/game-monitor.html?v=20260428-scoped-admin-telemetry"
        className="w-full h-full border-0 rounded-xl"
      />
    </div>
  );
}
